// extracted by mini-css-extract-plugin
export default {"banner":"UserDashboard_banner__w2zkj","resendLink":"UserDashboard_resendLink__t3CsR"};